import styled from 'styled-components'

import theme from 'theme_'

export const SubsManageBottomPanelWrapper = styled.div`
  max-width: ${theme.sizes.maxContentWidth};
  width: 100%;
  display: flex;
  flex-direction: column;
  justify-content: flex-end;
  padding: 16px 8px;
  gap: ${theme.spacing.xs};
  @media ${theme.devices.tablet} {
    flex-direction: row;
  }
`
export const SubsManageBottomPanelContainer = styled.div`
  position: fixed;
  bottom: 0;
  left: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  background-color: ${theme.colors.white};
  box-shadow: 0 4px 40px ${theme.colors.commonShadow};
  animation: ${theme.animations.fadeIn} 0.2s ease-out;
  z-index: ${theme.zIndex.modal};
`

export const StyledTotalToPay = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 16px;
  font-weight: 900;
  font-size: 20px;
  line-height: 24px;
  color: ${theme.colors.horizonOrange};
  @media ${theme.devices.tablet} {
    justify-content: flex-end;
    padding: 0;
  }
`

export const SubsManageBottomPanelButtonsWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 16px;
  padding: 0;
  button {
    width: 100%;
  }
  @media ${theme.devices.tablet} {
    button {
      width: fit-content;
    }
    padding: 0 32px;
  }
`
